import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import moment from 'moment';
import { COUPON_ID_DEVICE } from 'utils/constants';
import './CouponsTemplate.scss';
import BottomButton from 'components/common/BottomButton';

const CouponsTemplate = ({ coupons, onClickBtn }) => {
  const { t } = useTranslation('drawer');

  return (
    <div className="CouponsTemplate">
      {coupons.map((c, idx) => (
        <div key={idx} className="CouponsTemplate__item">
          <h4 className="name">{c.coupon_id.name.split('@')[0]}</h4>
          <div className="available text_greyishBrown">
            {/* 해당 제품 */}
            {c.coupon_id.name.split('@')[1] && (
              <span className="category">{c.coupon_id.name.split('@')[1]}</span>
            )}
            {c.coupon_id.id === COUPON_ID_DEVICE ? (
              <>출시 당일&nbsp;</>
            ) : (
              <>
                {/* 최소 금액 */}
                {c.coupon_id.minimum_price > 0 && (
                  <span>
                    <Trans
                      t={t}
                      i18nKey="minAmount"
                      values={{
                        amount: c.coupon_id.minimum_price.toLocaleString(),
                      }}
                    />
                  </span>
                )}
                {/* 1회구매 / 정기구독 */}
                {c.coupon_id.discount_type !== 'BOTH' && (
                  <span>
                    {c.coupon_id.discount_type === 'SUBSCRIBPTION'
                      ? t('onRegularSubscription')
                      : t('onPurchaseOnce')}
                  </span>
                )}
              </>
            )}
            {t('available')}
          </div>
          <div className="period text_greyishBrown">
            {c.coupon_id.id === COUPON_ID_DEVICE
              ? '2022.07월 중순 출시 예정'
              : c.coupon_id.end_date
              ? `${moment(c.start_date).format('YYYY. MM. DD.')} - ${moment(
                  c.end_date,
                ).format('YYYY. MM. DD.')}`
              : t('indefinite')}
          </div>
        </div>
      ))}
      <BottomButton onClick={onClickBtn}>{t('goToBuy')}</BottomButton>
    </div>
  );
};

export default CouponsTemplate;
